// resources/assets/js/acl.js
import Vue from 'vue'

const state = Vue.observable({
    roles: [] // array de strings limpas
})

const normalize = v => {
    if (v == null) return []
    if (Array.isArray(v)) return v.map(x => String(x).trim()).filter(Boolean)
    return String(v).split(',').map(x => x.trim()).filter(Boolean)
}

const Acl = {
    // inicializa a partir do usuário (padrão vazio)
    setUser(user) {
        const perms = user && user.tipo_user ? user.tipo_user : []
        state.roles = normalize(perms)
        // para debug:
        // console.log('[ACL] setUser -> roles =', state.roles)
    },

    // retorna array atual (reativo)
    getRoles() {
        return state.roles
    },

    // checa se o usuário tem **pelo menos uma** das permissões passadas
    // aceita string ou array
    can(check) {
        if (!check) return false
        const req = Array.isArray(check) ? check : [check]
        const reqNorm = req.map(x => String(x).trim()).filter(Boolean)
        return reqNorm.some(r => state.roles.includes(r))
    },

    // inverso
    cannot(check) {
        return !this.can(check)
    }
}

export default Acl
